<template>
  <div class="select-time-duration">
    <div class="select-group">
      <select v-model="timeValues.days"
              @change="emitChange"
              class="time-select">
        <option v-for="day in dayOptions"
                :key="day.value"
                :value="day.value">
          {{ day.label }}
        </option>
      </select>
      <span class="unit-label">天</span>
    </div>

    <div class="select-group">
      <select v-model="timeValues.hours"
              @change="emitChange"
              class="time-select">
        <option v-for="hour in hourOptions"
                :key="hour.value"
                :value="hour.value">
          {{ hour.label }}
        </option>
      </select>
      <span class="unit-label">小时</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectTimeDuration',
  props: {
    value: {
      type: Number, // 总秒数
      default: 0,
    },
    maxDays: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      timeValues: {
        days: 0,
        hours: 0,
        minutes: 0,
      },
    }
  },
  computed: {
    dayOptions() {
      const options = []
      for (let i = 0; i <= this.maxDays; i++) {
        options.push({
          value: i,
          label: i === 0 ? '0' : `${i}`,
        })
      }
      return options
    },
    hourOptions() {
      const options = []
      for (let i = 0; i < 24; i++) {
        options.push({
          value: i,
          label: i === 0 ? '0' : `${i}`,
        })
      }
      return options
    },
    // minuteOptions() {
    //   const options = []
    //   for (let i = 0; i < 60; i++) {
    //     options.push({
    //       value: i,
    //       label: i === 0 ? '0' : `${i}`,
    //     })
    //   }
    //   return options
    // },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.updateTimeValuesFromSeconds(newVal)
      },
    },
  },
  methods: {
    updateTimeValuesFromSeconds(totalSeconds) {
      let remaining = totalSeconds
      // 计算天数
      this.timeValues.days = Math.floor(remaining / 86400)
      remaining = remaining % 86400
      // 计算小时数
      this.timeValues.hours = Math.floor(remaining / 3600)
      remaining = remaining % 3600
      // 计算分钟数
      this.timeValues.minutes = Math.floor(remaining / 60)
    },
    getTotalSeconds() {
      return (
        this.timeValues.days * 86400 +
        this.timeValues.hours * 3600 +
        this.timeValues.minutes * 60
      )
    },
    emitChange() {
      this.$emit('input', this.getTotalSeconds())
      this.$emit('change', this.getTimeObject())
    },
    getTimeObject() {
      return {
        days: this.timeValues.days,
        hours: this.timeValues.hours,
        minutes: this.timeValues.minutes,
        totalSeconds: this.getTotalSeconds(),
      }
    },
  },
}
</script>

<style scoped>
.select-time-duration {
  display: flex;
  gap: 10px;
  align-items: center;
}

.select-group {
  display: flex;
  align-items: center;
  gap: 5px;
}

.time-select {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
}

.time-select:hover {
  border-color: #c0c4cc;
}

.time-select:focus {
  border-color: #409eff;
}

.unit-label {
  font-size: 14px;
  color: #606266;
}
</style>